import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex flex-col gap-2',
    link: 'group text-s hover:text-text-inactive flex justify-between border-b-1 border-[#D1D5DB] px-3 py-5 leading-[140%] font-medium duration-300 ease-in',
    icon: 'flex h-8 w-8 shrink-0 items-center justify-center',
    chevronIcon:
      'h-6 w-6 shrink-0 -rotate-90 justify-self-end opacity-0 duration-300 ease-in group-hover:opacity-100',
    counter:
      'text-m-bold max-lg:text-s flex items-center gap-1 self-start max-lg:leading-[1.5]',
    counterIcon: 'h-3 w-3 shrink-0'
  },
  variants: {
    active: {
      true: {
        link: 'bg-bg-items-white hover:bg-bg-items-white/50 focus:bg-bg-items-white/50 max-lg:bg-bg-items-white/50 max-lg:hover:bg-bg-items-white max-lg:focus:hover:bg-bg-items-white'
      }
    }
  },
  defaultVariants: {}
});
